import { AfterViewInit, Component, Inject, NgZone, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { CartService } from './shared/services/cart.service';
import { CompareService } from './shared/services/compare.service';
import { WishlistService } from './shared/services/wishlist.service';
import { ChildrenOutletContexts, NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser, ViewportScroller } from '@angular/common';
import { CurrencyService } from './shared/services/currency.service';
import { DirectionService } from './shared/services/direction.service';
import { ConnectionService } from 'ng-connection-service';
import { StoreService } from './shared/services/store.service';
import { Title } from '@angular/platform-browser';
import { CategoryService } from './shared/services/category.service';
import { Subscription } from 'rxjs';
import { environment as env } from '@environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: []
})
export class AppComponent implements AfterViewInit, OnInit, OnDestroy {

    status = 'ONLINE';
    isConnected = true;
    isAlert = false;

    private subscriptions = new Subscription();

    constructor(
        @Inject(PLATFORM_ID) private platformId: any,
        private router: Router,
        private toastr: ToastrService,
        private cart: CartService,
        private compare: CompareService,
        private wishlist: WishlistService,
        private zone: NgZone,
        private scroller: ViewportScroller,
        private currency: CurrencyService,
        private direction: DirectionService,
        private connectionService: ConnectionService,
        public storeService: StoreService,
        private titleService: Title,
        private categoryService: CategoryService,
        private contexts: ChildrenOutletContexts
    ) {

        // get direction : ltr|rtl
        const detectedDirection = (localStorage.getItem('dir') as 'ltr' | 'rtl') || 'ltr';
        localStorage.setItem('dir', detectedDirection);
        this.direction.value = detectedDirection;

        // get language : en|fa|...
        const detectedLanguage = localStorage.getItem('lan') || 'EN';
        localStorage.setItem('lan', detectedLanguage);

        this.subscriptions.add(this.connectionService.monitor().subscribe((state: any) => {
            this.isConnected = state.hasNetworkConnection; // This is probably the correct property
            if (this.isConnected) {
                this.status = 'ONLINE';
            } else {
                this.status = 'OFFLINE';
            }
        }));

        this.subscriptions.add(this.categoryService.GetAll().subscribe(x => {
            // console.log(x);
            const items = [];
            x.forEach(element => {
                const item = {
                    id: element.id,
                    label: element.name,
                    url: './shop/category/' + element.id + '/' + element.name.replace(' ', '_'),
                    external: false,
                    products: 572,
                    image: element.image?.path,
                    icon: element.image?.Thumbnail64
                };
                // console.log(item);
                items.push(item);
            });
            localStorage.setItem('categories', JSON.stringify(items));
            // this.items = items;
        }));
    }

    getRouetAnimationData() {
        return this.contexts.getContext('primary')?.route?.snapshot?.data?.['animation'];
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    ngOnInit(): void {

        // set title of application
        this.titleService.setTitle(this.storeService.getKeywords('Site_Title'));

        // properties of the CurrencyFormatOptions interface fully complies
        // with the arguments of the built-in pipe "currency"
        // https://angular.io/api/common/CurrencyPipe
        const storedCurrency = localStorage.getItem('currency');
        if (storedCurrency) {
            try {
                const parsed = JSON.parse(storedCurrency);
                this.currency.options = {
                    code: parsed.code || parsed,
                    display: parsed.symbol || parsed.display || '$',
                    digitsInfo: '1.0-0',
                    locale: 'en-US'
                };
            } catch {
                this.currency.options = {
                    code: storedCurrency,
                    display: '$',
                    digitsInfo: '1.0-0',
                    locale: 'en-US'
                };
            }
        } else {
            this.currency.options = {
                code: env.defaultCurrency || 'USD',
                display: env.defaultCurrencyDisplay || '$',
                digitsInfo: '1.0-0',
                locale: 'en-US'
            };
        }

        this.router.events.subscribe((event) => {
            if ((event instanceof NavigationEnd)) {
                this.scroller.scrollToPosition([0, 0]);
            }
        });

        this.cart.onAdding$.subscribe(product => {
            this.toastr.success(` "${product.name}" ${this.storeService.getKeywords('added_to_cart!')}`);
        });

        this.compare.onAdding$.subscribe(product => {
            this.toastr.success(` "${product.name}" ${this.storeService.getKeywords('added_to_compare!')}`);
        });

        this.wishlist.onAdding$.subscribe(product => {
            this.toastr.success(` "${product.name}" ${this.storeService.getKeywords('added_to_wish_list!')}`);
        });

    }

    ngAfterViewInit(): void {
        /**/
        if (isPlatformBrowser(this.platformId)) {
            this.zone.runOutsideAngular(() => {
                setTimeout(() => {
                    const preloader = document.querySelector('.site-preloader');

                    preloader.addEventListener('transitionend', (event: TransitionEvent) => {
                        if (event.propertyName === 'opacity') {
                            preloader.remove();
                        }
                    });
                    preloader.classList.add('site-preloader__fade');
                }, 0);
            });
        }
    }
}
